import React, { useEffect, useState } from "react";
import {
  utcDateTimeWithTimeZoneWithFormat,
  getOrdinal,
  humanize,
} from "../../services/Util";

import Constants from "../../Constants";
import { useSelector } from "react-redux";
import APIUrls from "../../services/APIUrls";
import { RotatingLines } from "react-loader-spinner";
import CustomProgressBar from "../global/CustomProgressBar";
import {
  getAxiosResponse,
} from "../../services/authApiRoutes/APImethods";
import { useNavigate } from "react-router-dom";
import { handleError } from "../../services/authApiRoutes/APImethods";
import $ from "jquery";
export default function ProjectLanguageDetail(prop) {
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const navigate = useNavigate();

  const projectId = prop.project_id;
  const langCode = prop.language_detail.displayName[0]?.code;
  const [potentialWorkflowAssignees, setPotentialWorkflowAssignees] = useState(
    []
  );
  const [constPhaseAssignee,setConstPhaseAssignee] = useState({})
  const [assignees, setAssignees] = useState([]);
  const [phaseAssignee, setPhaseAssignee] = useState([]);
  const [constAssignees, setConstAssignees] = useState([]);
  const [assigneeId, setAssigneeId] = useState([]);
  const [phaseAssigneeUsers, setAssigneeUsers] = useState([]);
  const [showReviewers, setShowReviewers] = useState("");
  const [options, setOptions] = useState({});
  const [showLangDetail, toggleLangDetail] = useState(false);
  const [languageDetail, setLanguages] = useState([]);
  const [reviewAssignees, setReviewAssignees] = useState([]);
  const [showSteps, setShowSteps] = useState([]);
  const [showstaticReviewers, setShowstaticReviewers] = useState("");
  const [phaseDetail, setPhaseDetail] = useState([]);
  const [targetAssetData, setTargetAsserData] = useState([]);
  const [dataLoader, setLoadedState] = useState(true);
  const [phaseTask, setPhaseTask] = useState([]);
  const [selectedTranslatedAsset, setSelectedTranslatedAsset] = useState({});
  const [assetId, setAssetId] = useState("");
  const [workflowPhase, setWorkFlowPhase] = useState();
  const [languagePhase, setlanguagePhase] = useState();

    const hideModel = () =>{
 document.body.classList.remove("modal-open");
    }
   
    const openStaticReviewers = (id) => {
      showstaticReviewers === id
        ? setShowstaticReviewers("")
        : setShowstaticReviewers(id);
        setTimeout(() => {
          showstaticReviewers === id ? $(document.activeElement).removeAttr("aria-labelledby") :
          $(document.activeElement).attr("aria-labelledby", "assigneeDetails");
        }, 300);
    };
    const getEntryUserAssigneeStatue = (phaseId,entryId) => {
      const loginUserId = options?.user?.userId
      var record = phaseAssignee.find((pa)=>{
        return ((pa.phase.id === phaseId && pa.asset.id === entryId && pa.user.userId === loginUserId))
      })
      return record ? record.status : 'NOT_ASSIGNEE'
    }
  const getData = () => {
    getAxiosResponse(APIUrls.LANGUAGE_STATUS(projectId, langCode))
      .then((res) => {
        if (res.data !== "") {
          setLanguages(res.data.data);
          var assigneeUserPhaseId = [];
          res.data.data.steps.map((step, index) => {
            step.phases.map((phase, phaseIndex) => {
              if (phase.assigneeType.code === "vendor") {
                assigneeUserPhaseId.push({
                  phaseId: phase.id,
                  allowMultiAssignee: phase?.allowMultiAssignee,
                  users: phase.assigneeVendor.name,
                  assigneeType: phase.assigneeType.code,
                });
              } else {
                assigneeUserPhaseId.push({
                  phaseId: phase.id,
                  allowMultiAssignee: phase?.allowMultiAssignee,
                  users: phase.assigneeUsers,
                  assigneeType: phase.assigneeType.code,
                });
              }
            });
          });
          setConstPhaseAssignee(assigneeUserPhaseId)
          setAssigneeUsers(assigneeUserPhaseId);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    getAxiosResponse(
      APIUrls.PROJECT_LANGUAGE_WORKFOLW_COMPOSED_DATA(projectId, langCode)
    ).then((res) => {
      setShowSteps(false);
      if (res.data !== "") {
        setPhaseDetail(res.data.data);
        var count = [];
        res.data.data?.map((phase, phaseIndex) => {
          if (phase.phaseType.originalEnum === "WORK") {
            if (phase.work.current.length > 0) {
              count.push(phase.stepNumber);
            } else if (phase.work.complete.length > 0) {
              count.push(phase.stepNumber);
            }
            if (phase.revision.current.length > 0) {
              count.push(phase.stepNumber);
            }
            if (
              Object.keys(phase.revision.complete).length !== 0 &&
              phase.revision.complete[1] !== null
            ) {
              let key = Object.keys(phase.revision.complete)[0];

              Object.keys(phase.revision.complete).map((round, roundNum) => {
                count.push(phase.stepNumber);
              });
            }
          } else if (phase.phaseType.originalEnum === "REVIEW") {
            if (!phase.review.current.length) {
              Object.keys(phase?.review?.current).map((round, roundNum) => {
                count.push(phase.stepNumber);
              });
            }
            if (phase.review.complete.length > 0) {
              count.push(phase.stepNumber);
            }
            if (phase.approved?.length > 0) {
              count.push(phase.stepNumber);
            }
          }
        });
      }
      setShowSteps(count);
    });
    getAxiosResponse(APIUrls.TARGET_ASSET_DATA(projectId, langCode))
      .then((res) => {
        if (res.data !== "") {
          setTargetAsserData(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    showLangDetail ? toggleLangDetail(false) : toggleLangDetail(true);
  };
  const showDetail = (projectId, langCode, e) => {
    if (e.type === "click" || e.key === "Enter") {
      getData(projectId, langCode);
    }
  };

  const createReviewLink = (phaseId, entry, targetAssetData, selectedPhase,access) => {
    getAxiosResponse(
      APIUrls.PHASE_ASIGNEE(projectId, entry.id, selectedPhase.phaseId)
    ).then((res) => {
      setReviewAssignees(res.data.data);
    });

    getAxiosResponse(
      APIUrls.ALL_TASKS + `?phaseId=${phaseId}&onlyFollowed=false`
    )
      .then((res) => {
        if (res.data !== "") {
          setPhaseTask(res.data.data?.result);
        } else {
          setPhaseTask([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedTranslatedAsset(entry);
    setAssetId(entry.id);
    var assetPhase = [];
    setWorkFlowPhase(selectedPhase);
    languageDetail.steps.forEach((step) => {
      if (step.stepNumber == selectedPhase.stepNumber) {
        step.phases.forEach((phase) => {
          if (phase.id == phaseId) {
            assetPhase = phase;
          }
        });
      }
    });

    setlanguagePhase(assetPhase);
    var asset = targetAssetData.filter((asset) => {
      return asset.currentPhaseId === phaseId;
    });
    if (entry.reviewId) {
      if (entry.lineByLineEnabled) {
        navigate(
          `/project/${projectId}/review/${phaseId}/${langCode}/${entry.reviewId}`,{state:{'access':access}}
        );
      } else {
        var data = {
          phaseId:phaseId, entry:entry, assetData:targetAssetData, phase:selectedPhase,langCode:langCode
        }
        navigate(`/project/${projectId}`,{state:data});
      }
    }
    hideModel()
  };
  const openReviewers = (id) => {
    showReviewers === id ? setShowReviewers("") : setShowReviewers(id);
  };
  
  const doesPhaseHaveOpenReviewAssets = (selectedPhaseId) => {
    var phaseBucket = phaseDetail.filter((phase) => {
      return phase.phaseId === selectedPhaseId;
    })[0];
    let key = Object.keys(phaseBucket.review.current);
    if (
      phaseBucket &&
      phaseBucket.review &&
      phaseBucket.review.current &&
      phaseBucket.review.current[key] !== undefined
    ) {
      return true;
    } else {
      return false;
    }
  };
  const isCurrentUser = (step, phaseIndex) => {
    var selectedPhase = step.phases.filter((phase) => {
      return phase.id === phaseIndex;
    });
    var selectedPhaseAssigneeUserIds = [];
    if (selectedPhase.length > 0) {
      selectedPhase[0].assigneeUsers.map((users) => {
        selectedPhaseAssigneeUserIds.push(users.userId);
      });
    }
    var assigneUserSameAsLoginUser = false;
    if (selectedPhaseAssigneeUserIds.includes(options?.user?.userId)) {
      assigneUserSameAsLoginUser = true;
    }
    if (options.user !== undefined) {
      if (
        assigneUserSameAsLoginUser ||
        options.user.roleSet.value === "ROLE_VENDOR_SYSTEM" ||
        options.user.roleSet.value === "ROLE_VENDOR" ||
        options.user.roleSet.value === "ROLE_CUSTOMER" ||
        options.user.roleSet.value === "ROLE_CUSTOMER_PROJECT_MANAGER" ||
        options.user.roleSet.value === "ROLE_CUSTOMER_SYSTEM"
      ) {
        return true;
      } else {
        return false;
      }
    }
  };
  const AssigneeEditableReadOnly = (prop) => {
    var selectedStep = prop.step;
    var selectedPhase = prop.phase;
    var phaseIndex = prop.phaseIndex;
    var html = [];
    languageDetail?.steps?.map((step) => {
      if (step?.stepNumber === selectedStep?.stepNumber) {
        step?.phases?.map((phase) => {
          if (phase?.phaseNumber === selectedPhase?.phaseNumber) {
            if (phase?.assignedToVendor) {
              if (phase?.assigneeType?.code === "customer_user") {
                if (options?.permissions && options?.permissions?.PROJECT_CUD) {
                  html = (
                    <div className="name 65 global-dropdown-select">
                      <div
                        className="role-admin-btn defaultSelect 1"
                        tabIndex="0"
                        aria-expanded={showReviewers === selectedPhase.phaseId + "-" + phaseIndex
                        }
                        onClick={() =>
                          openReviewers(
                            selectedPhase.phaseId + "-" + phaseIndex
                          )
                        }
                        role="button"
                      >
                        {phaseAssigneeUsers && phaseAssigneeUsers.length > 0 && phaseAssigneeUsers?.map((users, index) => {
                          if (
                            users?.phaseId === selectedPhase?.phaseId &&
                            users?.assigneeType === "customer_user"
                          ) {
                            return users?.users.map((user, userIndex) => {
                              if (users?.allowMultiAssignee) {
                                if (userIndex === 0)
                                  return (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="19"
                                      viewBox="0 0 24 19"
                                      fill="none"
                                    >
                                      <path
                                        d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z"
                                        fill="#64748B"
                                        stroke="#64748B"
                                        strokeWidth="0.2"
                                      />
                                    </svg>
                                  );
                                else {
                                  return (
                                    <span
                                      key={userIndex - selectedPhase?.phaseId}
                                    >
                                      {" "}
                                      {user?.fullName}
                                    </span>
                                  );
                                }
                              } else {
                                return (
                                  <span key={userIndex}> {user?.fullName}</span>
                                );
                              }
                            });
                          } else if (
                            users?.assigneeType === "vendor" &&
                            users?.phaseId === selectedPhase?.phaseId
                          ) {
                            return users?.users;
                          }
                        })}
                      </div>
                      <div
                        className={
                          showReviewers ===
                          selectedPhase.phaseId + "-" + phaseIndex
                            ? "global-dropdown action-display-revert-overflow width246 show p-5 max-heightInherit"
                            : "global-dropdown action-display-revert-overflow width246 p-5"
                        }
                        style={{ padding: "10px" }}
                      >
                        <div className="global-dropdown-select small-dropdown-select assignee-remove-block">
                          <div className="multiselect-output mar-bot16">
                            {phaseAssigneeUsers.length > 0
                              ? phaseAssigneeUsers?.map((users, index) => {
                                  if (
                                    users?.allowMultiAssignee &&
                                    users.phaseId === selectedPhase.phaseId
                                  ) {
                                    return users.users.map((user, index) => {
                                      return (
                                        <button
                                          key={index}
                                        >
                                          <strong>
                                            {user.firstName +
                                              " " +
                                              user.lastName}
                                          </strong>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="10"
                                            height="9"
                                            viewBox="0 0 10 9"
                                            fill="none"
                                          >
                                            <path
                                              d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                              stroke="#213248"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            ></path>
                                          </svg>
                                        </button>
                                      );
                                    });
                                  }
                                })
                              : null}
                          </div>
                         
                        </div>
                      </div>
                    </div>
                  );
                }
              } else {
                html = (
                  <div className="name 3">
                    {phaseAssigneeUsers && phaseAssigneeUsers?.length > 0 &&  phaseAssigneeUsers.map((users, index) => {
                      if (
                        users?.phaseId === selectedPhase?.phaseId &&
                        users?.assigneeType === "customer_user"
                      ) {
                        return users?.users?.map((user, userIndex) => {
                          return (
                            <span key={userIndex + 3}> {user?.fullName}</span>
                          );
                        });
                      } else if (
                        users?.assigneeType === "vendor" &&
                        users?.phaseId === selectedPhase?.phaseId
                      ) {
                        return (
                          <span key={index + 2} className="vendor-user">
                            {" "}
                            {users.users}
                          </span>
                        );
                      }
                    })}
                  </div>
                );
              }
            } else{
              phaseAssigneeUsers && phaseAssigneeUsers?.length > 0 && 
              phaseAssigneeUsers?.map((users, index) => {
                if (users?.phaseId === selectedPhase?.phaseId) {
                  if (users?.users && users?.users?.length > 0) {
                    users.users.map((user, userIndex) => {
                      if (phase.allowMultiAssignee) {
                          html = (
                            <div className="name 65 global-dropdown-select">
                              <div
                                className="role-admin-btn defaultSelect 2"
                                tabIndex="0"
                                aria-expanded={
                                  showReviewers ===
                                  selectedPhase.phaseId + "-" + phaseIndex
                                    ? "true"
                                    : "false"
                                }
                                onClick={() =>
                                  openReviewers(
                                    selectedPhase.phaseId + "-" + phaseIndex
                                  )
                                }
                                role="button"
                              >
                                {phaseAssigneeUsers && phaseAssigneeUsers.length > 0 && phaseAssigneeUsers?.map((users, index) => {
                                  if (
                                    users?.phaseId === selectedPhase?.phaseId &&
                                    users?.assigneeType === "customer_user"
                                  ) {
                                    return users?.users.map((user, userIndex) => {
                                      if (phase.allowMultiAssignee) {
                                         if (userIndex === 0){
                                          return (
                                            <div className="left flex-center role-admin-btn">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="19"
                                              viewBox="0 0 24 19"
                                              fill="none"
                                            >
                                              <path
                                                d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z"
                                                fill="#64748B"
                                                stroke="#64748B"
                                                strokeWidth="0.2"
                                              />
                                            </svg>
                                            <strong>
                                              {users?.users.lenght > 0 ? `${users?.users.lenght} reviewers selected` : ''}
                                              </strong>
                                              <div className="right flex-center">
                                               <button
                                                className="dropdown-icon"
                                                aria-label="dropdown data"
                                                aria-expanded={(showReviewers === selectedPhase.phaseId + "-" + phaseIndex)?'true':'false'}
                                               >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="20"
                                                  height="20"
                                                  viewBox="0 0 20 20"
                                                  fill="none"
                                                >
                                                  <path
                                                    d="M13.9136 9.08375L10.0011 12.9962L6.08865 9.08375L7.17743 8.00263L9.89507 10.7203L10.0011 10.8263L10.1072 10.7203L12.8248 8.00263L13.9136 9.08375ZM0.984473 10C0.984473 5.02288 5.02398 0.983374 10.0011 0.983374C14.9783 0.983374 19.0178 5.02288 19.0178 10C19.0178 14.9772 14.9783 19.0167 10.0011 19.0167C5.02398 19.0167 0.984473 14.9772 0.984473 10ZM2.51781 10C2.51781 14.1346 5.86663 17.4834 10.0011 17.4834C14.1356 17.4834 17.4845 14.1346 17.4845 10C17.4845 5.86553 14.1356 2.51671 10.0011 2.51671C5.86663 2.51671 2.51781 5.86553 2.51781 10Z"
                                                    fill="#1D4ED8"
                                                    stroke="#F4F9FF"
                                                    strokeWidth="0.3"
                                                  />
                                                </svg>
                                               </button>
                                             </div>
                                            </div>    
                                          );
                                        } 
                                      } else {
                                        return (
                                          <span key={userIndex}> {user?.fullName}</span>
                                        );
                                      }
                                    });
                                  } else if (
                                    users?.assigneeType === "vendor" &&
                                    users?.phaseId === selectedPhase?.phaseId
                                  ) {
                                    return users?.users;
                                  }
                                })}
                              </div>
                              <div
                                className={
                                  showReviewers ===
                                  selectedPhase.phaseId + "-" + phaseIndex
                                    ? "global-dropdown action-display-revert-overflow width246 show p-5 max-heightInherit"
                                    : "global-dropdown action-display-revert-overflow width246 p-5"
                                }
                                style={{ padding: "10px" }}
                              >
                                <div className="small-dropdown-select assignee-remove-block">
                                  <div className=" multiselect-output mar-bot16">
                                    {phaseAssigneeUsers.length > 0
                                      ? phaseAssigneeUsers?.map((users, index) => {
                                          if (
                                            users?.allowMultiAssignee &&
                                            users.phaseId === selectedPhase.phaseId
                                          ) {
                                            return users.users.map((user, index) => {
                                              return (
                                                <button
                                                  key={index}
                                                >
                                                  <strong>
                                                    {user.firstName +
                                                      " " +
                                                      user.lastName}
                                                  </strong>
                                                </button>
                                              );
                                            });
                                          }
                                        })
                                      : null}
                                  </div>
                                </div>
                               
                              </div>
                            </div>
                          );
                      } else {
                        if (
                          doesPhaseHaveOpenReviewAssets(
                            selectedPhase.phaseId
                          ) &&
                          options?.permissions &&
                          options?.permissions?.PROJECT_CUD
                        ) {
                          html = (
                            <div className="name 65 global-dropdown-select">
                              <div
                                className="role-admin-btn defaultSelect"
                                tabIndex="0"
                                aria-expanded={
                                  showReviewers ===
                                  selectedPhase.phaseId + "-" + phaseIndex
                                    ? "true"
                                    : "false"
                                }
                                onClick={() =>
                                  openReviewers(
                                    selectedPhase.phaseId + "-" + phaseIndex
                                  )
                                }
                                role="button"
                              >
                                {phaseAssigneeUsers?.map((users, index) => {
                                  if (
                                    users.phaseId === selectedPhase.phaseId &&
                                    users.assigneeType === "customer_user"
                                  ) {
                                    return users.users.map(
                                      (user, userIndex) => {
                                        if (users?.allowMultiAssignee) {
                                          if (userIndex === 0)
                                            return (
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="19"
                                                viewBox="0 0 24 19"
                                                fill="none"
                                              >
                                                <path
                                                  d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z"
                                                  fill="#64748B"
                                                  stroke="#64748B"
                                                  strokeWidth="0.2"
                                                />
                                              </svg>
                                            );
                                          else {
                                            return (
                                              <span key={userIndex}>
                                                {" "}
                                                {user.fullName}
                                              </span>
                                            );
                                          }
                                        } else {
                                          return (
                                            <div class="left flex-center role-admin-btn" role="button">
                                              <span>{user.fullName}</span>
                                              {phase.allowMultiAssignee ? 
                                              <div class="right flex-center">
                                                <button class="dropdown-icon" aria-label="dropdown data" aria-expanded="false">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M13.9136 9.08375L10.0011 12.9962L6.08865 9.08375L7.17743 8.00263L9.89507 10.7203L10.0011 10.8263L10.1072 10.7203L12.8248 8.00263L13.9136 9.08375ZM0.984473 10C0.984473 5.02288 5.02398 0.983374 10.0011 0.983374C14.9783 0.983374 19.0178 5.02288 19.0178 10C19.0178 14.9772 14.9783 19.0167 10.0011 19.0167C5.02398 19.0167 0.984473 14.9772 0.984473 10ZM2.51781 10C2.51781 14.1346 5.86663 17.4834 10.0011 17.4834C14.1356 17.4834 17.4845 14.1346 17.4845 10C17.4845 5.86553 14.1356 2.51671 10.0011 2.51671C5.86663 2.51671 2.51781 5.86553 2.51781 10Z" fill="#1D4ED8" stroke="#F4F9FF" stroke-width="0.3"></path>
                                                  </svg>
                                                  </button>
                                                  </div>
                                                  :""}
                                                  </div>
                                          );
                                        }
                                      }
                                    );
                                  } else if (
                                    users.assigneeType === "vendor" &&
                                    users.phaseId === selectedPhase.phaseId
                                  ) {
                                    return users.users;
                                  }
                                })}
                              </div>
                              <div
                                className={
                                  (showReviewers === selectedPhase.phaseId + "-" + phaseIndex && phase.allowMultiAssignee)
                                    ? "global-dropdown action-display-revert-overflow width246 show p-5 max-heightInherit"
                                    : "global-dropdown action-display-revert-overflow width246 p-5"
                                }
                                style={{ padding: "10px" }}
                                
                              >
                                <div className="global-dropdown-select small-dropdown-select assignee-remove-block">
                                  <div className="multiselect-output mar-bot16">
                                    {phaseAssigneeUsers.length > 0
                                      ? phaseAssigneeUsers?.map(
                                          (users, index) => {
                                            if (
                                              users?.allowMultiAssignee &&
                                              users.phaseId ===
                                                selectedPhase.phaseId
                                            ) {
                                              return users.users.map(
                                                (user, index) => {
                                                  return (
                                                    <button
                                                      key={index}
                                                    >
                                                      <strong>
                                                        {user.firstName +
                                                          " " +
                                                          user.lastName}
                                                      </strong>
                                                      
                                                    </button>
                                                  );
                                                }
                                              );
                                            }
                                          }
                                        )
                                      : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        } else {
                          html = (
                            <div>
                              <span key={userIndex}> {user.fullName}</span>
                            </div>
                          );
                        }
                      }
                    });
                  } else {
                    html = (
                      <div className="name 65 global-dropdown-select">
                        <div
                          className="role-admin-btn defaultSelect"
                          tabIndex="0"
                          aria-expanded={
                            showReviewers ===
                            selectedPhase.phaseId + "-" + phaseIndex
                              ? "true"
                              : "false"
                          }
                          onClick={() =>
                            openReviewers(
                              selectedPhase.phaseId + "-" + phaseIndex
                            )
                          }
                          role="button"
                        >
                          {(()=> {
                          if(phase.allowMultiAssignee ){
                           return(
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="19"
                                viewBox="0 0 24 19"
                                fill="none"
                              >
                                <path
                                  d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z"
                                  fill="#64748B"
                                  stroke="#64748B"
                                  strokeWidth="0.2"
                                />
                              </svg>
                            )
                         
                        }else{
                          phaseAssignee.map((assignee) => {
                            return (
                              <span>
                                {assignee.user.firstName +
                                  " " +
                                  assignee.user.lastName}
                              </span>
                            );
                          })
                        }
                      })()}
                     
                        </div>
                        <div
                          className={
                            showReviewers ===
                            selectedPhase.phaseId + "-" + phaseIndex
                              ? "global-dropdown action-display-revert-overflow width246 show p-5 max-heightInherit"
                              : "global-dropdown action-display-revert-overflow width246 p-5"
                          }
                          style={{ padding: "10px" }}
                        >
                          <div className="global-dropdown-select small-dropdown-select assignee-remove-block">
                            <div className="multiselect-output mar-bot16">
                              {phaseAssigneeUsers.length > 0
                                ? phaseAssigneeUsers?.map((users, index) => {
                                    if (
                                      users?.allowMultiAssignee &&
                                      users.phaseId === selectedPhase.phaseId
                                    ) {
                                      return users.users.map((user, index) => {
                                        return (
                                          <button
                                            key={index}
                                          >
                                            <strong>
                                              {user.firstName +
                                                " " +
                                                user.lastName}
                                            </strong>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="10"
                                              height="9"
                                              viewBox="0 0 10 9"
                                              fill="none"
                                            >
                                              <path
                                                d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                                stroke="#213248"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              ></path>
                                            </svg>
                                          </button>
                                        );
                                      });
                                    }
                                  })
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                } else if (
                  users.assigneeType === "vendor" &&
                  users.phaseId === selectedPhase.phaseId
                ) {
                  html = (
                    <div>
                      <span key={index}> {users.users}</span>
                    </div>
                  );
                }
              });
            }
          }
        });
      }
    });
    return html;
  };
  
  $(".user.ml-15").on("keydown", function (e) {
    $(document).mouseup(function(e) {
        var bannerCont = $('.global-dropdown-select.mr-15');
        if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
            setShowstaticReviewers("")
        }
      });
     if (e.key === Constants.ESCAPE) {
         setShowstaticReviewers("")
         $(e.target).trigger("focus");
      }
      if (e.key === Constants.TAB) {
        setShowstaticReviewers("")
        $(e.target).trigger("focus");
     }
  });
  useEffect(() => {
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setOptions(res.data.data);
    });
    getAxiosResponse(APIUrls.LANGUAGE_ASIGNEE_(projectId, langCode)).then(
      (res) => {
        setPhaseAssignee(res.data.data);
      }
    );
    getAxiosResponse(APIUrls.CUSTOMER_DEPARTMENT_USERS_REVIEW(projectId)).then(
      (res) => {
        if (res.data.code === 200) {
          var users = [];
          res.data.data.map((data) => {
            users.push(data.resource.customerUser);
          });
          setPotentialWorkflowAssignees(users);
          setConstAssignees(users);
        }
      }
    );
    getAxiosResponse(APIUrls.PROJECT_VISIBILITY_USER(projectId)).then((res) => {
      if (res.data.code === 200) {
        var users = [];
        res.data.data.map((data) => {
          users.push(data.resource);
        });
        setAssignees(users);
        setConstAssignees(users);
      }
    });
  }, []);
  return (
    <div className="modal-content">
      <div className="advance-filter">
        <div className="advance-filter-list">
          <div
            className="language-block"
            role="button"
            aria-label={
              prop.language_detail.displayName[0]?.display + " language, " +
              (prop.language_detail.resource.openWorkflowTask.dueDate !== "" ?
                utcDateTimeWithTimeZoneWithFormat(
                  prop.language_detail.resource.openWorkflowTask.dueDate,
                  'll',
                  custBootstrapDataRedux.user?.timeZone
                )+' due date' : "") +
              ", progress " +
              (prop.language_detail.resource.percentComplete !== "" ?
                Math.round(prop.language_detail.resource.percentComplete) : 0) +
              "% completed"
            }
            aria-expanded={showLangDetail ? 'true' : 'false'}
            onClick={(e) => showDetail(projectId, langCode, e)}
            onKeyDown={(event) => showDetail(projectId, langCode, event)}
            tabIndex={0}
          >
            <div className="flex justify-center">
              <strong>{prop.language_detail.displayName[0]?.display}</strong>
              <div className="due-date">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    d="M10.5 1.2H8.7V0.3C8.7 0.220435 8.66839 0.144129 8.61213 0.087868C8.55587 0.0316071 8.47957 0 8.4 0C8.32044 0 8.24413 0.0316071 8.18787 0.087868C8.13161 0.144129 8.1 0.220435 8.1 0.3V1.2H3.9V0.3C3.9 0.220435 3.86839 0.144129 3.81213 0.087868C3.75587 0.0316071 3.67957 0 3.6 0C3.52044 0 3.44413 0.0316071 3.38787 0.087868C3.33161 0.144129 3.3 0.220435 3.3 0.3V1.2H1.5C1.10232 1.20048 0.721067 1.35866 0.439866 1.63987C0.158665 1.92107 0.000476357 2.30232 0 2.7V10.5C0.000476357 10.8977 0.158665 11.2789 0.439866 11.5601C0.721067 11.8413 1.10232 11.9995 1.5 12H10.5C10.8977 11.9997 11.2791 11.8415 11.5603 11.5603C11.8415 11.2791 11.9997 10.8977 12 10.5V2.7C11.9997 2.30227 11.8415 1.92093 11.5603 1.63969C11.2791 1.35846 10.8977 1.20032 10.5 1.2ZM11.4 10.5C11.4 10.7387 11.3052 10.9676 11.1364 11.1364C10.9676 11.3052 10.7387 11.4 10.5 11.4H1.5C1.26131 11.4 1.03239 11.3052 0.863604 11.1364C0.694821 10.9676 0.6 10.7387 0.6 10.5V5.4H11.4V10.5ZM11.4 4.8H0.6V2.7C0.6 2.2032 1.002 1.8 1.5 1.8H3.3V2.7C3.3 2.77957 3.33161 2.85587 3.38787 2.91213C3.44413 2.96839 3.52044 3 3.6 3C3.67957 3 3.75587 2.96839 3.81213 2.91213C3.86839 2.85587 3.9 2.77957 3.9 2.7V1.8H8.1V2.7C8.1 2.77957 8.13161 2.85587 8.18787 2.91213C8.24413 2.96839 8.32044 3 8.4 3C8.47957 3 8.55587 2.96839 8.61213 2.91213C8.66839 2.85587 8.7 2.77957 8.7 2.7V1.8H10.5C10.7387 1.8 10.9676 1.89482 11.1364 2.0636C11.3052 2.23239 11.4 2.46131 11.4 2.7V4.8Z"
                    fill="#0976C6"
                  />
                </svg>
                <span>
                  {prop.language_detail.resource.openWorkflowTask.dueDate !== ""
                    ? utcDateTimeWithTimeZoneWithFormat(
                        prop.language_detail.resource.openWorkflowTask.dueDate,
                        Constants.API_DATE_FORMAT,
                        custBootstrapDataRedux.user?.timeZone
                      )
                    : ""}
                </span>{" "}
                Due Date
              </div>
            </div>
            <div className="flex-center slide-bar-block">
              <CustomProgressBar
                bgColor="rgb(106, 27, 154)"
                baseBgColor="rgb(106 27 154 / 44%)"
                labelSize=""
                labelPadding="0 0 0 14px"
                labelClassName="languageProgressBarLabel"
                labelAlignment="outside"
                borderRadius="2px"
                labelColor="rgba(0,0,0,0.87)"
                width="85%"
                height="6px"
                outerDivClassName="project_tracking_progress"
                completed={
                  prop.language_detail.resource.percentComplete !== ""
                    ? Math.round(prop.language_detail.resource.percentComplete)
                    : 0
                }
                customLabel=""
              />
              {/* <div className="slide-bar">
                  <span style={{ width: "40%", background: "#FF49A1" }}></span>
                </div>
                <strong>40%</strong> */}
            </div>
          </div>

          <div
            className={
              showLangDetail
                ? "filter-assignee-block"
                : "filter-assignee-block hide"
            }
          >
            {languageDetail.steps && languageDetail.steps.length !== 0 ? (
              languageDetail.steps.map((step, stepIndex) => {
                return (
                  <div
                    className={
                      showSteps.includes(step.stepNumber) ? "langDetails" : "hide noData"
                    }
                    style={
                      showSteps.includes(step.stepNumber)
                        ? {
                            border: "2px solid #DCE5E8",
                            padding: "5px",
                            marginBottom: "5px",
                            borderRadius: "3px",
                          }
                        : {}
                    }
                  >
                    {phaseDetail.map((phase, phaseIndex) => {
                      var template = [];
                      if (phase.stepNumber === stepIndex + 1) {
                        if (phase.phaseType.originalEnum === "WORK") {
                          if (phase.work.current.length > 0) {
                            template.push(
                              <div
                                className="filter-assignee-list"
                                key={phaseIndex}
                              >
                                <div className="assignee-title 1">
                                  <strong>
                                    {phase.phaseName}{" "}
                                    <span>( Phase {phase.phaseNumber} )</span>
                                  </strong>
                                </div>
                                <div
                                  id="assignee-box"
                                  className={
                                     "assignee-box"
                                  }
                                >
                                  <div className="flex-center justify-center">
                                    <AssigneeEditableReadOnly
                                      step={step}
                                      phase={phase}
                                      phaseIndex={phaseIndex}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          } else if (phase.work.complete.length > 0) {
                            template.push(
                              <div
                                className="filter-assignee-list"
                                key={phaseIndex}
                              >
                                <div className="assignee-title 2">
                                  <strong>
                                    {phase.phaseName}{" "}
                                    <span>( Phase {phase.phaseNumber} )</span>
                                  </strong>
                                </div>
                                <div
                                  id="assignee-box"
                                  className={
                                     "assignee-box"
                                  }
                                >
                                  <div className="flex-center justify-center">
                                    <AssigneeEditableReadOnly
                                      step={step}
                                      phase={phase}
                                      phaseIndex={phaseIndex}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          }
                          if (
                            Object.keys(phase.revision.complete).length !== 0 &&
                            phase.revision.complete[1] !== undefined
                          ) {
                            Object.keys(phase.revision.complete).map(
                              (round, roundNum) => {
                                template.push(
                                  <div
                                    className="filter-assignee-list"
                                    key={phaseIndex}
                                  >
                                    <div className="assignee-title 3">
                                      <strong>
                                        {"Revision " + Number(round)}{" "}
                                        <span>
                                          ( Phase {phase.phaseNumber} )
                                        </span>
                                      </strong>
                                    </div>
                                    <div
                                      id="assignee-box"
                                      className={
                                        "assignee-box"
                                      }
                                    >
                                      <div className="flex-center justify-center">
                                        <AssigneeEditableReadOnly
                                          step={step}
                                          phase={phase}
                                          phaseIndex={phaseIndex}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            );
                          }
                          if (phase.revision.current.length > 0) {
                            template.push(
                              <div
                                className="filter-assignee-list"
                                key={phaseIndex}
                              >
                                <div className="assignee-title 4">
                                  <strong>
                                    In Revision{" "}
                                    <span>( Phase {phase.phaseNumber} )</span>
                                  </strong>
                                </div>
                                <div
                                  id="assignee-box"
                                  className={
                                     "assignee-box"
                                  }
                                >
                                  <div className="flex-center justify-center">
                                    <AssigneeEditableReadOnly
                                      step={step}
                                      phase={phase}
                                      phaseIndex={phaseIndex}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        } else if (phase.phaseType.originalEnum === "REVIEW") {
                          if (!phase.review.current.length) {
                            let reviewKey = Object.keys(phase.review.current);
                            var lastPhase = Object.keys(
                              phase?.review?.current
                            ).map((round, roundNum) => {
                              return (
                                <div
                                  className="filter-assignee-list"
                                  key={phaseIndex}
                                >
                                  <div className="assignee-title 5">
                                    <strong>
                                      {phase.phaseName}{" "}
                                      {round > 1
                                        ? round + getOrdinal(round) + " Round"
                                        : ""}{" "}
                                      <span>( Phase {phase.phaseNumber} )</span>
                                    </strong>
                                  </div>
                                  <div
                                    id="assignee-box"
                                    className={
                                       "assignee-box"
                                    }
                                  >
                                    <div className="flex-center justify-center">
                                      <AssigneeEditableReadOnly
                                        step={step}
                                        phase={phase}
                                        phaseIndex={phaseIndex}
                                      />
                                    </div>
                                  </div>
                                  <ul className="uploaded-doc-list">
                                    {phase?.review?.current[round]?.map(
                                      (entry, i) => (
                                        <li className="flex-center justify-center">
                                          <div className="left flex-center">
                                            <strong>{i + 1}.</strong>
                                            <span>{entry?.name}</span>
                                            <div className="global-dropdown-select mr-15 width-auto">
                                                        <button
                                                          aria-label="assignee"
                                                          className="user ml-15"
                                                          aria-expanded={(showstaticReviewers === phase.phaseId + "-" + entry.id)?"true":"false"}
                                                          onClick={(e) =>
                                                            openStaticReviewers(
                                                              phase.phaseId +
                                                                "-" +
                                                                entry.id
                                                            )
                                                          }
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="22"
                                                            height="22"
                                                            viewBox="0 0 22 22"
                                                            fill="none"
                                                          >
                                                            <path
                                                              d="M11 5.5C10.3201 5.5 9.65552 5.70161 9.09023 6.07932C8.52494 6.45704 8.08434 6.9939 7.82417 7.62203C7.56399 8.25015 7.49592 8.94131 7.62855 9.60812C7.76119 10.2749 8.08858 10.8874 8.56932 11.3682C9.05007 11.8489 9.66257 12.1763 10.3294 12.3089C10.9962 12.4416 11.6874 12.3735 12.3155 12.1133C12.9436 11.8532 13.4805 11.4126 13.8582 10.8473C14.2359 10.282 14.4375 9.61737 14.4375 8.9375C14.4375 8.02582 14.0753 7.15148 13.4307 6.50682C12.786 5.86216 11.9117 5.5 11 5.5ZM11 11C10.5921 11 10.1933 10.879 9.85414 10.6524C9.51496 10.4258 9.25061 10.1037 9.0945 9.72678C8.93839 9.34991 8.89755 8.93521 8.97713 8.53513C9.05671 8.13504 9.25315 7.76754 9.54159 7.47909C9.83004 7.19065 10.1975 6.99421 10.5976 6.91463C10.9977 6.83505 11.4124 6.87589 11.7893 7.032C12.1662 7.1881 12.4883 7.45246 12.7149 7.79164C12.9415 8.13081 13.0625 8.52958 13.0625 8.9375C13.062 9.48434 12.8445 10.0086 12.4578 10.3953C12.0711 10.782 11.5468 10.9995 11 11Z"
                                                              fill="#1D4ED8"
                                                            ></path>
                                                            <path
                                                              d="M11 1.375C9.09636 1.375 7.23546 1.9395 5.65264 2.99711C4.06982 4.05471 2.83616 5.55793 2.10766 7.31667C1.37917 9.07541 1.18856 11.0107 1.55995 12.8777C1.93133 14.7448 2.84802 16.4598 4.1941 17.8059C5.54018 19.152 7.25519 20.0687 9.12226 20.4401C10.9893 20.8114 12.9246 20.6208 14.6833 19.8923C16.4421 19.1638 17.9453 17.9302 19.0029 16.3474C20.0605 14.7645 20.625 12.9036 20.625 11C20.6221 8.44818 19.6071 6.00172 17.8027 4.19731C15.9983 2.39291 13.5518 1.37791 11 1.375ZM6.875 18.1342V17.1875C6.87555 16.6407 7.09302 16.1164 7.4797 15.7297C7.86638 15.343 8.39066 15.1255 8.9375 15.125H13.0625C13.6093 15.1255 14.1336 15.343 14.5203 15.7297C14.907 16.1164 15.1245 16.6407 15.125 17.1875V18.1342C13.8732 18.8651 12.4496 19.2503 11 19.2503C9.5504 19.2503 8.12683 18.8651 6.875 18.1342ZM16.4945 17.1366C16.4808 16.2349 16.1134 15.3746 15.4714 14.7411C14.8295 14.1076 13.9644 13.7517 13.0625 13.75H8.9375C8.03563 13.7517 7.17052 14.1076 6.52857 14.7411C5.88661 15.3746 5.51921 16.2349 5.5055 17.1366C4.25877 16.0234 3.37957 14.5577 2.98433 12.9337C2.58909 11.3097 2.69645 9.60392 3.29219 8.04228C3.88794 6.48063 4.94397 5.13677 6.32045 4.18864C7.69693 3.24051 9.32893 2.73283 11.0003 2.73283C12.6718 2.73283 14.3038 3.24051 15.6802 4.18864C17.0567 5.13677 18.1128 6.48063 18.7085 8.04228C19.3042 9.60392 19.4116 11.3097 19.0164 12.9337C18.6211 14.5577 17.7419 16.0234 16.4952 17.1366H16.4945Z"
                                                              fill="#1D4ED8"
                                                            ></path>
                                                          </svg>
                                                        </button>
                                                        <div
                                                          id={showstaticReviewers === phase.phaseId + "-" + entry.id?"assigneeDetails":""}
                                                          className={
                                                            showstaticReviewers ===
                                                            phase.phaseId +
                                                              "-" +
                                                              entry.id
                                                              ? "global-dropdown action-display2 width246 show p-5 max-heightInherit"
                                                              : "global-dropdown action-display2 width246 hide"
                                                          }
                                                          style={{left:"-100px !important"}}
                                                        >
                                                          <ul>
                                                            {phaseAssigneeUsers?.map(
                                                              (
                                                                users,
                                                                index
                                                              ) => {
                                                                if (
                                                                  users.phaseId ===
                                                                    phase.phaseId &&
                                                                  users.assigneeType ===
                                                                    "customer_user"
                                                                ) {
                                                                  return users.users.map(
                                                                    (
                                                                      user,
                                                                      userIndex
                                                                    ) => {
                                                                      return (
                                                                        <li
                                                                          className="p-5"
                                                                          key={
                                                                            userIndex +
                                                                            2
                                                                          }
                                                                        >
                                                                          {
                                                                            user.fullName
                                                                          }{" "}
                                                                          {phaseAssignee.map(
                                                                            (
                                                                              assignee,
                                                                              index
                                                                            ) => {
                                                                              if (
                                                                                assignee
                                                                                  .user
                                                                                  .userId ===
                                                                                  user.userId &&
                                                                                assignee
                                                                                  .asset
                                                                                  .id ===
                                                                                  entry.id
                                                                              ) {
                                                                                return (
                                                                                  <strong
                                                                                    key={
                                                                                      index
                                                                                    }
                                                                                  >
                                                                                    (
                                                                                    {humanize(
                                                                                      assignee.status
                                                                                    )}

                                                                                    )
                                                                                  </strong>
                                                                                );
                                                                              }
                                                                            }
                                                                          )}
                                                                        </li>
                                                                      );
                                                                    }
                                                                  );
                                                                } else if (
                                                                  users.assigneeType ===
                                                                    "vendor" &&
                                                                  users.phaseId ===
                                                                    phase.phaseId
                                                                ) {
                                                                  return users.users;
                                                                }
                                                              }
                                                            )}
                                                          </ul>
                                                        </div>
                                                      </div>
                                          </div>
                                          {(() => {
                                            if (entry.status === "IN_REVIEW") {
                                              <div className="btn-txt">
                                                {options.reviewerMode &&
                                                !targetAssetData[0].lineByLineEnabled ? (
                                                  <button></button>
                                                ) : (
                                                  <button
                                                    className="active dashboard-btn 1"
                                                    onClick={() =>
                                                      createReviewLink(
                                                        phase.phaseId,
                                                        entry,
                                                        targetAssetData,
                                                        phase,'review'
                                                      )
                                                    }
                                                  >
                                                    Review{" "}
                                                  </button>
                                                )}
                                              </div>;
                                              if (
                                                phase?.phaseIsMultiAssignee &&
                                                phase.assignedToSilo &&
                                                phase.assigneeVendor === ''
                                              ) {
                                                if(getEntryUserAssigneeStatue(phase.phaseId,entry.id) === "NOT_STARTED" ||
                                                 getEntryUserAssigneeStatue(phase.phaseId,entry.id) === "OPENED") {
                                                            return <button
                                                              className="btn width98"
                                                              onClick={() =>
                                                                createReviewLink(
                                                                  phase.phaseId,
                                                                  entry,
                                                                  targetAssetData,
                                                                  phase,'review'
                                                                )
                                                              }
                                                            >Review
                                                            </button>
                                                  }else{ 
                                                            return <button
                                                            className="btn width98"
                                                            onClick={() =>
                                                              createReviewLink(
                                                                phase.phaseId,
                                                                entry,
                                                                targetAssetData,
                                                                phase,'view'
                                                              )
                                                            }
                                                          >View
                                                          </button>}
                                              } else if (phase.approvalPhase) {
                                                if (
                                                  phase.assignedToContextUser
                                                ) {
                                                  return (
                                                    <button
                                                      className="active dashboard-btn 3"
                                                      onClick={() =>
                                                        createReviewLink(
                                                          phase.phaseId,
                                                          entry,
                                                          targetAssetData,
                                                          phase,'review'
                                                        )
                                                      }
                                                    >
                                                      Approve
                                                    </button>
                                                  );
                                                } else {
                                                  return (
                                                    <button
                                                      className="active dashboard-btn 4"
                                                      onClick={() =>
                                                        createReviewLink(
                                                          phase.phaseId,
                                                          entry,
                                                          targetAssetData,
                                                          phase,'view'
                                                        )
                                                      }
                                                    >
                                                      View{" "}
                                                    </button>
                                                  );
                                                }
                                              } else {
                                                if (
                                                  phase.assignedToSilo &&
                                                  isCurrentUser(step,phase.phaseId)
                                                ) {
                                                  return (
                                                    <button
                                                      className="active dashboard-btn 5"
                                                      projectdetail-tour="review-btn"
                                                      onClick={() =>
                                                        createReviewLink(
                                                          phase.phaseId,
                                                          entry,
                                                          targetAssetData,
                                                          phase,'review'
                                                        )
                                                      }
                                                    >
                                                      Review{" "}
                                                    </button>
                                                  );
                                                } else {
                                                  return (
                                                    <button
                                                      className="active dashboard-btn 6"
                                                      onClick={() =>
                                                        createReviewLink(
                                                          phase.phaseId,
                                                          entry,
                                                          targetAssetData,
                                                          phase,'view'
                                                        )
                                                      }
                                                    >
                                                      View
                                                    </button>
                                                  );
                                                }
                                              }
                                            } else {
                                              return (
                                                <strong>
                                                  {humanize(entry.status)}
                                                </strong>
                                              );
                                            }
                                          })()}
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              );
                            });
                            template.push(lastPhase);
                          }
                          if (phase.review.complete.length > 0) {
                            template.push(
                              <div
                                className="filter-assignee-list"
                                key={phaseIndex}
                              >
                                <div className="assignee-title 6">
                                  <strong>
                                    {phase.phaseName}
                                    <span>( Phase {phase.phaseNumber} )</span>
                                  </strong>
                                </div>
                                <div
                                  id="assignee-box"
                                  className={
                                     "assignee-box"
                                  }
                                >
                                  <div className="flex-center justify-center">
                                    <AssigneeEditableReadOnly
                                      step={step}
                                      phase={phase}
                                      phaseIndex={phaseIndex}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          }
                          if (phase.approved?.length > 0) {
                            template.push(
                              <div
                                className="filter-assignee-list"
                                key={phaseIndex}
                              >
                                <div className="assignee-title 7">
                                  <strong>
                                    Approved{" "}
                                    <span>( Phase {phase.phaseNumber} )</span>
                                  </strong>
                                </div>
                                <div
                                  id="assignee-box"
                                  className={
                                     "assignee-box"
                                  }
                                >
                                  <AssigneeEditableReadOnly
                                   step={step}
                                   phase={phase}
                                   phaseIndex={phaseIndex}
                                  />
                                </div>
                              </div>
                            );
                          }
                        }
                      } else {
                        template.push("");
                      }
                      return template;
                    })}
                  </div>
                );
              })
            ) : (
              <div className="dataLoading" style={{ textAlign: "center" }}>
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  width="96"
                  visible={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
